import React, { ReactNode, useContext, useMemo } from 'react'

export type TFunction = (key: string, keywords?: string[]) => string

interface UIComponentsProviderContext {
  t: TFunction | null
  formatDate: Function | null
  ImageComponent: React.ElementType
  LinkComponent: React.ElementType
}

const UIComponentsContext = React.createContext<UIComponentsProviderContext>({
  t: null,
  formatDate: null,
  ImageComponent: null,
  LinkComponent: null,
})

const UIComponentsProvider = ({
  children,
  t,
  formatDate,
  LinkComponent,
  ImageComponent,
}: {
  children: ReactNode
  t: UIComponentsProviderContext['t']
  formatDate: UIComponentsProviderContext['formatDate']
  LinkComponent: UIComponentsProviderContext['LinkComponent']
  ImageComponent: UIComponentsProviderContext['ImageComponent']
}) => {
  const contextValue = useMemo(
    () => ({ t, formatDate, LinkComponent, ImageComponent }),
    [t, formatDate, LinkComponent, ImageComponent]
  )

  return (
    <UIComponentsContext.Provider value={contextValue}>
      {children}
    </UIComponentsContext.Provider>
  )
}

export const useUIComponentsContext = () => {
  const context = useContext(UIComponentsContext)

  return context
}

export default UIComponentsProvider
